import { InputValueType } from '../../../../api/generated';
import { useFetchCases } from '../../../../hooks/useFetchCases';
import { useFetchComputeSettings } from '../../../../hooks/useFetchComputeSettings';

export const useResultMetadata = (computeCaseId?: string) => {
  const { data: computeCases } = useFetchCases();
  const { data: computeSettings } = useFetchComputeSettings();

  // Find the compute case for this result
  const caseFilter = computeCases?.find(
    (c) => c.computeCaseId === computeCaseId,
  );

  // Determine model area display name - handle empty strings too
  const modelArea = caseFilter?.modelArea?.name?.trim() || 'Whole model';

  // Get compute method
  const computeMethod = caseFilter?.computeMethod;

  // Find archel setting
  const archelSetting = computeSettings?.objectComputeSettings?.find(
    (setting) =>
      caseFilter?.inputSettings?.find(
        (s) => s.inputValueType === InputValueType.ARCHEL,
      )?.computeSettingId === setting.computeSettingId,
  );
  const archelName = archelSetting?.equinorName ?? archelSetting?.name ?? '';

  return {
    modelArea,
    computeMethod,
    archelName,
  };
};
